import { useState, useEffect } from 'react';

const STORAGE_KEY = 'favorite_tokens';

export const useFavoriteTokens = () => {
  const [favorites, setFavorites] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error('Failed to save favorites:', error);
    }
  }, [favorites]);

  const isFavorite = (tokenAddress) => {
    return favorites.some(fav => 
      fav.address?.toLowerCase() === tokenAddress?.toLowerCase()
    );
  };

  const toggleFavorite = (token) => {
    setFavorites(prev => {
      const exists = prev.some(fav => 
        fav.address?.toLowerCase() === token.address?.toLowerCase()
      );
      
      if (exists) {
        return prev.filter(fav => 
          fav.address?.toLowerCase() !== token.address?.toLowerCase()
        );
      } else {
        return [...prev, {
          address: token.address,
          symbol: token.symbol,
          name: token.name,
          logo: token.logo,
          decimals: token.decimals,
          addedAt: Date.now()
        }];
      }
    });
  };

  const clearFavorites = () => {
    setFavorites([]);
  };

  return {
    favorites,
    isFavorite,
    toggleFavorite,
    clearFavorites
  };
};